// extracted by css-extract-rspack-plugin
export default {"ProTipContainer":"ReposListProTip-module__ProTipContainer__tahTM","ProTip":"ReposListProTip-module__ProTip__AirS3","ProTipCode":"ReposListProTip-module__ProTipCode__Mnygo"};